<template>
  <span>

    <section class="pb-0.5 lg:pb-4 pt-14 lg:pt-32 bg-top bg-no-repeat bg-cover"
             :style="{ 'background-image': heroBackgroundStyle }">
    <div class="my-8 sm:mx-auto sm:w-full sm:max-w-6xl px-4 sm:px-6 flex items-end justify-items-end">

        <div class="flex-shrink-0">
          <img :src="campaign.defaultLogo" alt=""
               class="border-4 border-white mr-5 rounded-full bg-white h-24 w-24 lg:h-36 lg:w-36 rounded-full object-cover">
        </div>

        <div>
          <h1 class="text-2xl lg:text-4xl text-white font-medium leading-none block break-word overflow-ellipsis overflow-hidden">
            {{ campaign.name }}
          </h1>
            <a v-if="campaign.parent" :href="'/campaigns/' + campaign.parent.id"
               class="text-white text-xs lg:text-lg mt-2 border-b border-white font-medium hover:text-gray-200 hover:border-gray-200">Raising funds for {{ campaign.parent.name }} ››</a>
        </div>
    </div>
</section>



<div class="min-h-full relative bg-white pt-6 lg:pt-16 pb-20 flex px-0">
    <div class="sm:w-full max-w-6xl mx-auto px-4 sm:px-6 mx-auto flex flex-col lg:flex-row">

        <div class="w-full lg:w-2/12 text-center justify-center">
          <share-link :campaign-id="campaign.id" :campaign="campaign" :show-header="true"></share-link>
        </div>

        <hr class="lg:hidden my-5">

        <div class="w-full lg:w-7/12 lg:pr-10">

           <div class="flex flex-col space-y-6">
              <standard-campaign-goal v-if="campaign.campaign_type_id == 1 || campaign.campaign_type_id == 3"
                                      :campaign-id="campaign.id" :campaign="campaign"></standard-campaign-goal>

              <pledge-drive-campaign-goal v-if="campaign.campaign_type_id == 2" :campaign-id="campaign.id"
                                          :campaign="campaign"></pledge-drive-campaign-goal>

              <div>
                <my-donate-button :campaign-id="campaign.id" :pledge-id="pledgeId"
                                  :campaign="campaign"></my-donate-button>
              </div>
           </div>

          <hr class="my-8 lg:my-10">
          <h2 class="uppercase font-medium mb-6 text-center">About Our Campaign</h2>
          <campaign-page-message v-if="!campaign.isPledgeDrive" :message="campaign.message"></campaign-page-message>
          <campaign-pledge-drive-page-message v-if="campaign.isPledgeDrive"
                                              :message="campaign.message"></campaign-pledge-drive-page-message>

          <hr class="my-8 lg:my-10">
          <h2 class="uppercase font-medium mb-6 text-center lg:mt-20">Our Campaign Activity</h2>

          <campaign-activities :campaign-id="campaignId"></campaign-activities>


        </div>


        <highlighted-blog-posts-legacy :campaign-id="campaign.id" :campaign="campaign"></highlighted-blog-posts-legacy>


      </div>
    </div>

<section
    class="bg-white w-full z-10 shadow-md campaign-fixed-bar opacity-0 transition-opacity duration-400 ease-in-out campaign-bar">
        <my-sticky-donate-button :campaign-id="campaign.id" :pledge-id="pledgeId"
                                 :campaign="campaign"></my-sticky-donate-button>
    </section>
  </span>
</template>

<script>
import HighlightedBlogPostsLegacy from './highlighted-blog-posts/HighlightedBlogPostsLegacy'
import CampaignPageMessage from './CampaignPageMessage'
import CampaignActivities from './activities/CampaignActivities'
import StandardCampaignGoal from './campaign-goal/StandardCampaignGoal'
import PledgeDriveCampaignGoal from './campaign-goal/PledgeDriveCampaignGoal'
import CampaignPledgeDrivePageMessage from "./CampaignPledgeDrivePageMessage"
import CampaignEventDisplay from "./events/CampaignEventDisplay"

export default {
  name: 'CampaignPage',
  components: {
    CampaignPledgeDrivePageMessage,
    PledgeDriveCampaignGoal,
    StandardCampaignGoal,
    CampaignPageMessage,
    HighlightedBlogPostsLegacy,
    CampaignActivities,
    CampaignEventDisplay,
  },
  props: {
    campaignId: {
      type: String,
      required: true,
    },

    pledgeId: {
      required: false,
    },

    myCampaign: {
      type: Object,
      required: false,
    },
  },

  data() {
    return {
      isVisible: true,
      campaign: this.myCampaign,
      timer: null,
      timer1: null,
      tabFocus: true,
    }
  },

  created() {
    this.isLoading = true

    this.emitter.on('campaign-donation-update', (campaign) => {
      this.campaign = campaign
    })

    this.captureView()

    this.timer = setInterval(() => {
      this.captureView()
    }, 30000);
    // }, 5000);
  },

  beforeUnmount() {
    clearInterval(this.timer)
    clearInterval(this.timer1)
  },
  methods: {
    visibilityChanged(isVisible, entry) {
      this.isVisible = isVisible
    },
    captureView() {
      try {
        axios.post('/capture-view', {id: this.campaign.id})
            .then(response => {
              // console.log(response)
            })
      } catch (error) {
        clearInterval(this.timer)
      }


    },
  },

  async mounted() {


// toggle class on sticky bar based on scroll location
    const campaignButtons = document.querySelector(".campaign-buttons")
    const campaignFixedBar = document.querySelector(".campaign-fixed-bar")
    const add_class_on_scroll = () => campaignFixedBar.classList.add("opacity-100", "active", "fixed")
    const remove_class_on_scroll = () => campaignFixedBar.classList.remove("opacity-100", "active", "fixed")
    window.onscroll = function () {
      if (campaignButtons.getBoundingClientRect().bottom <= 0) {
        add_class_on_scroll();
      } else {
        remove_class_on_scroll();
      }
    }


    this.isLoading = false

    this.timer1 = setInterval(() => {
      this.progressCounter = this.campaign.funded
    }, 1000)

    // /* Auto Rotate Tabs for Impact Playbook */
    // var tabChange = function(){
    //   var tabs = $('#impactPlaybook .nav-item > a');
    //   var active = tabs.filter('.active');
    //   var next = active.closest('li').next('li').length ? active.closest('li').next('li').find('a') : $('#impactPlaybook .nav-item').filter(':first-child').find('a');
    //   next.tab('show');
    // }
    //
    // var tabCycle = setInterval(tabChange, 4000);
    //
    // $('#impactPlaybook .nav-tabs a').click(function(e) {
    //   e.preventDefault();
    //   clearInterval(tabCycle);
    //   $(this).tab('show');
    // });

  },

  computed: {

    heroBackgroundClass() {
      const availableClasses = [
        'hero-purple-blue',
        'hero-blue',
        'hero-green',
        'hero-pink',
        'hero-red',
      ]

      return availableClasses[Math.floor(Math.random() * availableClasses.length)]
    },

    heroBackgroundStyle() {
      return `linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, .5) 70%, rgba(0, 0, 0, .5) 100%), url('` + this.campaign.hero_image_path + `')`
    },
  },

}
</script>
